import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { borderRadius } from './borderRadius';
import { shadows } from './shadows';

export const components = {
  // Common component patterns
  menuItem: {
    base: {
      alignSelf: 'stretch',
      background: 'transparent',
      borderRadius: borderRadius.small,
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: spacing.sm,
      display: 'flex',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: colors.interaction.hover
      }
    },
    collapsed: {
      padding: `${spacing.md}px ${spacing.lg}px`,
      justifyContent: 'center',
      gap: 0,
      minWidth: 48,
    },
    expanded: {
      padding: `${spacing.lg}px`,
    },
    active: {
      background: colors.primary.main,
      '&:hover': {
        backgroundColor: colors.primary.hover
      }
    }
  },
  
  card: {
    base: {
      backgroundColor: colors.background.paper,
      borderRadius: borderRadius.medium,
      boxShadow: shadows.card,
      padding: spacing.lg,
    },
    elevated: {
      boxShadow: shadows.lg,
    }
  },
  
  drawer: {
    paper: {
      backgroundColor: colors.background.paper,
      boxShadow: shadows.drawer,
      border: 'none',
    }
  },
  
  icon: {
    small: {
      width: 16,
      height: 16,
    },
    medium: {
      width: 24,
      height: 24,
    },
    large: {
      width: 32,
      height: 32,
    }
  },
  
  text: {
    menuItem: {
      fontSize: typography.fontSize.medium,
      fontFamily: typography.fontFamily.primary,
      fontWeight: typography.fontWeight.bold,
      lineHeight: typography.lineHeight.tight,
      whiteSpace: 'nowrap' as const,
      minWidth: 'max-content',
    },
    heading: {
      fontSize: typography.fontSize.xxl,
      fontFamily: typography.fontFamily.primary,
      fontWeight: typography.fontWeight.bold,
      color: colors.primary.main,
    },
    body: {
      fontSize: typography.fontSize.medium,
      fontFamily: typography.fontFamily.primary,
      fontWeight: typography.fontWeight.normal,
      lineHeight: typography.lineHeight.normal,
    }
  },
  
  layout: {
    drawerWidth: {
      expanded: 280,
      collapsed: 80,
    },
    header: {
      height: 64,
    }
  }
} as const;